import { configureStore } from '@reduxjs/toolkit';

import { IAppReduxState } from './models';
import accountReducer from './reducers/account-reducer';
import coreReducer from './reducers/core-reducer';
import billReducer from './reducers/bill-reducer';
import userInputReducer from './reducers/user-input-reducer';
import visualizerReducer from './reducers/visualizer-reducer';

const reducer = {
  account: accountReducer,
  core: coreReducer,
  bill: billReducer,
  visualizer: visualizerReducer,
  userInput: userInputReducer,
};

const store = configureStore<IAppReduxState>({
  reducer,
});

export { reducer, store };
